import React from 'react';
import { Phone, MessageCircle, Clock } from 'lucide-react';
import { Button } from '../ui/button';
import { COMPANY_INFO } from '../../mock';

export const AbschlussBundesweit = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-br from-gray-900 via-black to-gray-900 relative overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-20 right-10 w-[400px] h-[400px] bg-brand-green/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-[500px] h-[500px] bg-brand-green/10 rounded-full blur-3xl"></div>
      
      <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-8 tracking-tight">
          Kurz abstimmen?
        </h2>
        <p className="text-xl lg:text-2xl text-gray-400 mb-12 max-w-3xl mx-auto font-normal">
          Schreiben Sie uns per WhatsApp oder rufen Sie an. Wir sagen Ihnen direkt, wie es im nächsten Schritt weitergeht.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
          <a href={`tel:${COMPANY_INFO.phone}`}>
            <Button size="lg" className="w-full sm:w-auto bg-brand-green hover:bg-brand-green-dark text-white text-lg px-10 py-7 rounded-2xl font-semibold shadow-2xl shadow-brand-green/30">
              <Phone className="w-5 h-5 mr-3" />
              Jetzt anrufen
            </Button>
          </a>
          <a href={`https://wa.me/${COMPANY_INFO.whatsapp}`} target="_blank" rel="noopener noreferrer">
            <Button size="lg" variant="outline" className="w-full sm:w-auto border-2 border-white text-white hover:bg-white hover:text-gray-900 text-lg px-10 py-7 rounded-2xl font-semibold">
              <MessageCircle className="w-5 h-5 mr-3" />
              WhatsApp schreiben
            </Button>
          </a>
        </div>

        <div className="flex items-center justify-center gap-2 text-gray-400">
          <Clock className="w-5 h-5" />
          <span className="text-sm font-medium">Schnelle Rückmeldung</span>
        </div>
      </div>
    </section>
  );
};